import { createI18n } from 'vue-i18n'
import { zh } from '@/i18n/zh'
import { en } from '@/i18n/en'
const messages = {
  en: en,
  zhCn: zh
}
export const i18n = createI18n({
  legacy: false,
  locale: 'zhCn', // set locale
  fallbackLocale: 'en', // set fallback locale
  messages
})

